import React from 'react'

export default function Pagenotfound() {
  return (
    <>
      <div className="container">
        <h1 className='text-danger'>404: Page Not Found</h1>
        <h6>Sorry, the page you are looking for does not exist.</h6>
      </div>
    </>
  )
}
